import React from "react";
import { useParams } from "react-router-dom";

const CBSEPdfViewer = () => {
  const { document } = useParams();

  const documents = {


     
       "AFFILIATION_LETTER_2026.pdf": "/CBSE/AFFILIATION_LETTER_2026.pdf",
    "NOC_2026.pdf": "/CBSE/NOC_2026.pdf",
   "ACADEMIC_CALENDER_2026.pdf": "/CBSE/ACADEMIC_CALENDER_2026.pdf",
    
     "BUILDING_SAFETY_CERTIFICATE_2026.pdf": "/CBSE/BUILDING_SAFETY_CERTIFICATE_2026.pdf",
     "WATER_HEALTH_SANITATION_CERTIFICATE_2026.pdf": "/CBSE/WATER_HEALTH_SANITATION_CERTIFICATE_2026.pdf",
    "INCOME_EXPENDITURE_2026.pdf": "/CBSE/INCOME_EXPENDITURE_2026.pdf",
    "BALANCE_SHEET_2026.pdf": "/CBSE/BALANCE_SHEET_2026.pdf",
    "LAND_CERTIFICATE_2026.pdf": "/CBSE/LAND_CERTIFICATE_2026.pdf",
    "NON_PROPRETARY_2026.pdf": "/CBSE/NON_PROPRETARY_2026.pdf",
    "SMC_2026.pdf": "/CBSE/SMC_2026.pdf",
    // "Self Certificate.pdf": "/CBSE/self certification.pdf",
   "SANITATION.pdf": "/CBSE/SANITATION.pdf",
    "/RECOGNITION_CERTIFICATE.pdf": "/CBSE/RECOGNITION_CERTIFICATE.pdf",
     "FIRE_SAFETY_CERTIFICATE_2026.pdf": "/CBSE/FIRE_SAFETY_CERTIFICATE_2026.pdf",
   "FEES_STRUCTURE_2026.pdf": "/CBSE/FEES_STRUCTURE_2026.pdf",
    "BOARD_RESULTS_2026.pdf": "/CBSE/BOARD_RESULTS_2026.pdf",
    "PTA_2026.pdf": "/CBSE/PTA_2026.pdf",
  "SOCIETY RENEWAL_CERTIFICATE_2026.pdf": "/CBSE/SOCIETY RENEWAL_CERTIFICATE_2026.pdf",

  };

  const pdfFile = documents[document];

  if (!pdfFile) {
    return <h2>Document not found</h2>;
  }

  return (
    <iframe
      src={pdfFile}
      title="CBSE PDF"
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
      }}
    />
  );
};

export default CBSEPdfViewer;